import { Icons } from '#/components/icons';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '#/components/ui/accordion';
import { Button } from '#/components/ui/button';
import { Label } from '#/components/ui/label';
import MultiSelect from '#/components/ui/select-mulit';
import { Separator } from '#/components/ui/separator';

import { Switch } from '#/components/ui/switch';
import { REVISIONCONFIGTYPE, useAlertModal, useRevisionConfig } from '#/hooks';
import { CheckConflictCall } from '#/lib/grpc-service';
import { Conflict } from '#/protobuf/bareun/custom_dict_pb';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { SelectItemType } from 'types/common';

import { ROUTES } from '#/data/constants';
import { useRouter } from 'next/navigation';
import { ChangeDictName } from '../custom-dict/[id]/components/utility';

export function RevisionConfigComponents({
  customDictionaryList,
  listRef,
  revisionConfigSelect,
  apiKey,
  isEditFlow
}: {
  customDictionaryList: SelectItemType[];
  listRef?: React.RefObject<SelectItemType[]>;
  revisionConfigSelect?: React.RefObject<REVISIONCONFIGTYPE>;
  apiKey: string;
  isEditFlow?: boolean;
}) {
  const route = useRouter();
  const {
    revisionConfig,
    setRevisionConfig,
    customDictionaryList: storeList,
    setCustomDictionaryList
  } = useRevisionConfig();
  const { close } = useAlertModal();
  const [list, setList] = useState<SelectItemType[]>(storeList);
  const [revisionConfigs, setRevisionsConfig] =
    useState<REVISIONCONFIGTYPE>(revisionConfig);

  const [check, setCheck] = useState<Conflict[]>([]);
  const TOGGLE_CONFIG_KEYS = [
    { key: 'disable_split_sentence', label: '문장 단위 분할' },
    { key: 'disable_caret_spacing', label: '복합명사 분리' },
    { key: 'disable_vx_spacing', label: '보조 용언 띄어쓰기' },
    { key: 'enable_cleanup_whitespace', label: '공백을 제거' },
    { key: 'enable_sentence_check', label: '문장 단위 점검' }
  ] as const;

  function toggleConfig(key: keyof typeof revisionConfig) {
    if (revisionConfigSelect) {
      const newRevisionsConfig = {
        ...revisionConfigs,
        [key]: !revisionConfigs[key]
      };
      console.log(newRevisionsConfig);
      setRevisionsConfig(newRevisionsConfig);
      revisionConfigSelect.current = newRevisionsConfig;
    } else {
      const newRevisionsConfig = {
        ...revisionConfig,
        [key]: !revisionConfig[key]
      };
      setRevisionConfig(newRevisionsConfig);
    }
  }

  function removeItem(from: number, to: number) {
    if (listRef) {
      const newList = [...list];
      newList.splice(from, 1); // 해당 항목 제거
      setList(newList);
      if (listRef) {
        listRef.current = newList;
      }
    } else {
      const newList = [...storeList];
      newList.splice(from, 1); // 해당 항목 제거
      setCustomDictionaryList(newList);
    }
  }

  function moveItem(from: number, to: number) {
    if (listRef) {
      if (to < 0 || to >= list.length) return;

      const newList = [...list];
      const [moved] = newList.splice(from, 1);
      newList.splice(to, 0, moved);
      console.log(newList);

      setList(newList);
      if (listRef) {
        listRef.current = newList;
      }
    } else {
      if (to < 0 || to >= storeList.length) return;

      const newList = [...storeList];
      const [moved] = newList.splice(from, 1);
      newList.splice(to, 0, moved);

      setCustomDictionaryList(newList);
    }
  }

  function listSpan(e: SelectItemType, i: number, length: number) {
    return (
      <div key={e.value} className="flex items-center gap-2">
        <span>{i + 1}.</span>
        <span className="flex-1">{e.label}</span>
        <div className="flex gap-1">
          <button
            disabled={i === 0}
            onClick={() => moveItem(i, i - 1)}
            className="text-sm cursor-pointer disabled:cursor-auto disabled:text-muted-foreground dark:disabled:text-muted-foreground"
          >
            <Icons.chevronUp />
          </button>
          <button
            disabled={i === length - 1}
            onClick={() => moveItem(i, i + 1)}
            className="text-sm cursor-pointer disabled:cursor-auto disabled:text-muted-foreground dark:disabled:text-muted-foreground"
          >
            <Icons.chevronDown />
          </button>
          <button
            onClick={() => removeItem(i, i + 1)}
            className="text-sm cursor-pointer  text-red-600"
          >
            <Icons.trash />
          </button>
        </div>
      </div>
    );
  }

  async function crashCheck() {
    let list: string[] = [];
    if (listRef) {
      list = listRef.current.map((e) => e.value);
    } else {
      list = storeList.map((e) => e.value);
    }

    console.log(list);
    const res = await CheckConflictCall(apiKey, list);
    if (res) {
      console.log(res);

      const result = res.filter((e) => !e.duplicated);
      if (result.length === 0) {
        toast.success('충돌이 없습니다.');
      }
      setCheck(result);
    }
  }

  function changeName(id: string, isRef: boolean) {
    if (id) {
      if (isRef) {
        const item = listRef?.current?.find((e) => e.value === id);
        if (item) {
          return item.label;
        }
      } else {
        const item = storeList.find((e) => e.value === id);
        if (item) {
          return item.label;
        }
      }
    }
    return '';
  }

  return (
    <div className="flex flex-col gap-2 pb-4">
      <div className="flex flex-col gap-2 ">
        <div className="flex justify-between items-center">
          <Label className="text-base ">적용할 사용자 사전</Label>
          <Button
            size="sm"
            onClick={async () => {
              await crashCheck();
            }}
            disabled={
              listRef
                ? list.length
                  ? false
                  : true
                : storeList.length
                  ? false
                  : true
            }
          >
            충돌 확인
          </Button>
        </div>
        {check.length > 0 && (
          <>
            <Accordion
              type="single"
              collapsible
              className="w-full"
              defaultValue="item-1"
            >
              <AccordionItem value="item-1">
                <AccordionTrigger>충돌 내용({check.length})</AccordionTrigger>
                <AccordionContent className="flex flex-col gap-2 text-balance max-h-[20vh] overflow-y-auto px-2 ">
                  {check.map((e, i) => (
                    <div key={i} className="flex flex-col gap-1">
                      <div className="text-red-600 flex gap-2">
                        충돌 단어: {e.leftWord}
                      </div>
                      <div className="text-muted-foreground flex gap-2">
                        충돌 사전이름:
                        <div className="flex items-center justify-between gap-2 flex-1">
                          <span className="text-primary">
                            {changeName(
                              e.left?.dictName ?? '',
                              listRef ? true : false
                            )}
                          </span>

                          <button
                            onClick={() => {
                              close();
                              route.push(
                                `${ROUTES.CUSTOM_DICT}/${e.left?.dictName ?? ''}`
                              );
                            }}
                          >
                            <Icons.link className="w-4 h-4 cursor-pointer" />
                          </button>
                        </div>
                      </div>
                      <div className="text-muted-foreground flex gap-2">
                        충돌 사전:{' '}
                        <span className="text-primary">
                          {ChangeDictName(e.left?.dictSetName ?? '')}
                        </span>
                      </div>
                      <div className="text-muted-foreground flex gap-2">
                        충돌 사전이름:
                        <div className="flex items-center justify-between gap-2 flex-1">
                          <span className="text-primary">
                            {changeName(
                              e.right?.dictName ?? '',
                              listRef ? true : false
                            )}
                          </span>

                          <button
                            onClick={() => {
                              close();
                              route.push(
                                `${ROUTES.CUSTOM_DICT}/${e.right?.dictName ?? ''}`
                              );
                            }}
                          >
                            <Icons.link className="w-4 h-4 cursor-pointer" />
                          </button>
                        </div>
                      </div>
                      <div className="text-muted-foreground flex gap-2">
                        충돌 사전:{' '}
                        <span className="text-primary">
                          {ChangeDictName(e.right?.dictSetName ?? '')}
                        </span>
                      </div>
                      {check.length - 1 !== i && <Separator />}
                    </div>
                  ))}
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </>
        )}

        <MultiSelect
          defaultText={'사용자 사전'}
          items={customDictionaryList}
          value={listRef ? list : storeList}
          onChange={(e) => {
            console.log(e);
            console.log(listRef);
            if (listRef) {
              setList(e);
              listRef.current = e;
            } else {
              setCustomDictionaryList(e);
            }
          }}
        />
        <div className="flex flex-col gap-2">
          {listRef
            ? list.map((e, i) => listSpan(e, i, list.length))
            : storeList.map((e, i) => listSpan(e, i, storeList.length))}
        </div>
      </div>
      {isEditFlow && (
        <>
          <Separator className="my-2" />
          {TOGGLE_CONFIG_KEYS.map(({ key, label }) => {
            if (
              key === 'disable_split_sentence' ||
              key === 'enable_sentence_check'
            ) {
              return;
            }
            return (
              <div className="flex flex-col gap-2" key={key}>
                <Label className="" htmlFor={key}>
                  {label}
                </Label>
                <Switch
                  id={key}
                  checked={
                    revisionConfigSelect
                      ? revisionConfigs[key]
                      : revisionConfig[key]
                  }
                  onCheckedChange={() => toggleConfig(key)}
                />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}
